var _rect, _rect2, _g, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_405_32206",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_405_32206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.53206 19.448H9.6045L16.2115 12.841L15.1391 11.7685L8.53206 18.3755V19.448ZM19.4863 11.7302L16.2307 8.51291L17.3031 7.44047C17.5968 7.14682 17.9574 7 18.3851 7C18.8128 7 19.1735 7.14682 19.4671 7.44047L20.5396 8.51291C20.8332 8.80655 20.9864 9.16084 20.9992 9.57578C21.012 9.99071 20.8715 10.345 20.5779 10.6386L19.4863 11.7302ZM18.3755 12.8601L10.2556 20.9801H7V17.7244L15.1199 9.6045L18.3755 12.8601Z",
    fill: "black"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#FFDF0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileChat);
export default __webpack_public_path__ + "static/media/file-chat.7b7506e7d39009272e4d809e063b0688.svg";
export { ForwardRef as ReactComponent };